import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import Modal from 'react-responsive-modal'
import classNames from 'classnames'

export default class FileManager extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    files: PropTypes.array.isRequired,
    documentTypes: PropTypes.array.isRequired,
    showUploadForm: PropTypes.bool.isRequired,
    toggleShowUploadForm: PropTypes.func.isRequired,
    onNewFileDocumentChange: PropTypes.func.isRequired,
    newDocumentFileInputTouched: PropTypes.bool.isRequired,
    newDocumentName: PropTypes.string.isRequired,
    newDocumentType: PropTypes.string.isRequired,
    onNewDocumentNameChange: PropTypes.func.isRequired,
    onNewDocumentTypeChange: PropTypes.func.isRequired,
    onNewDocumentSubmit: PropTypes.func.isRequired,
    newDocumentSubmitting: PropTypes.bool,
    newDocumentError: PropTypes.string,
    newDocumentValidateErrors: PropTypes.object,
    onRowSelected: PropTypes.func.isRequired,
    selectedRows: PropTypes.array.isRequired,
    onFileSubmitSelected: PropTypes.func,
    documentTypeId: PropTypes.oneOf([PropTypes.number, PropTypes.string])
  }

  constructor (props) {
    super(props)
    this.state = {
      columns: [
        {
          Header: (
            <div className="documents-browser-header-list">
              Nome
            </div>
          ),
          className: 'no-horizontal-border',
          accessor: 'name',
          filterable: true,
          sortable: true,
          filterMethod: (filter, row) => (row[filter.id].toLowerCase().includes(filter.value.toLowerCase())),
          Cell: row => {
            const isActive = row && this.props.selectedRows.indexOf(row.index) !== -1
            return (
              <div className={classNames('documents-browser-file-cell', {'white-text': isActive})}>
                {row.value}
              </div>
            )
          }
        },
        {
          Header: (
            <div className="documents-browser-header-list">
              Tipo
            </div>
          ),
          className: 'no-horizontal-border',
          accessor: 'DocumentType.name',
          filterable: false,
          sortable: true,
          Cell: row => {
            const isActive = row && this.props.selectedRows.indexOf(row.index) !== -1
            return (
              <div className={classNames('documents-browser-file-cell', {'white-text': isActive})}>
                {row.value}
              </div>
            )
          }
        }
      ]
    }
  }

  render () {
    const {
      files,
      loading,
      error,
      showUploadForm,
      toggleShowUploadForm,
      documentTypes,
      onNewFileDocumentChange,
      newDocumentFileInputTouched,
      newDocumentName,
      newDocumentType,
      onNewDocumentNameChange,
      onNewDocumentTypeChange,
      onNewDocumentSubmit,
      newDocumentSubmitting,
      newDocumentError,
      newDocumentValidateErrors,
      onRowSelected,
      selectedRows,
      onFileSubmitSelected,
      documentTypeId
    } = this.props
    const {
      columns
    } = this.state

    if (loading) {
      return (
        <div>
          <h4>Caricamento in corso...</h4>
        </div>
      )
    }

    if (error) {
      return (
        <div>
          <h5 className="text-danger">{error}</h5>
        </div>
      )
    }

    return (
      <div className="col-md-12" style={{minHeight: '350px'}}>
        <div className="col-md-12" style={{marginBottom: '10px'}}>
          {selectedRows.length > 0 && (
            <a onClick={onFileSubmitSelected} className="btn-download-user">
              Seleziona Documento
            </a>
          )}
          <a style={{float: 'right'}} onClick={toggleShowUploadForm} className="btn-file-browser-confirm">
            {!showUploadForm ? 'Carica Nuovo Documento' : 'Annulla Caricamento'}
          </a>
        </div>

        <div className="col-md-12">
          <ReactTable
            minRows={10}
            loading={loading}
            noDataText={'Nessun Documento Presente'}
            className="-highlight no-horizontal-border"
            data={files}
            showPagination={false}
            style={{maxHeight: '500px'}}
            defaultPageSize={files.length}
            loadingText="Caricamento in corso..."
            getTrGroupProps={(state, rowInfo, column) => {
              const isActive = rowInfo && selectedRows.indexOf(rowInfo.index) !== -1
              const activeStyle = {}

              if (isActive) {
                activeStyle.backgroundColor = '#2196F3'
              }
              return {
                style: {
                  borderBottom: 0,
                  ...activeStyle
                }
              }
            }}
            getTdProps={(state, rowInfo, column, instance) => {
              const isActive = rowInfo && selectedRows.indexOf(rowInfo.index) !== -1
              const activeStyle = {}
              if (isActive) {
                activeStyle.color = '#FFFFF'
              }
              return {
                onClick: (e, handleOriginal) => {
                  if (!rowInfo) {
                    return
                  }
                  onRowSelected(rowInfo.index, rowInfo.original)
                }
              }
            }}
            columns={columns} />
        </div>

        <Modal
          open={showUploadForm}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          classNames={{modal: 'container-fluid'}}
          onClose={toggleShowUploadForm}
        >
          <h3>Carica Nuovo Documento</h3>
          <div className="col-md-12">
            <div className="form-group">
              <label>File (pdf, jpeg, png, tiff - max: 2MB)</label>
              <input
                type="file"
                className="form-control-file"
                name="documentFile"
                onInput={onNewFileDocumentChange}
              />
              {newDocumentValidateErrors.file && (
                <span className="text-danger">{newDocumentValidateErrors.file}</span>
              )}
            </div>

            <div className="form-group">
              <label>Nome del documento</label>
              <input
                disabled={!newDocumentFileInputTouched}
                value={newDocumentName}
                onChange={onNewDocumentNameChange}
                type="text"
                className="form-control"
                name="documentName"
              />
              {newDocumentValidateErrors.name && (
                <span className="text-danger">{newDocumentValidateErrors.name}</span>
              )}
            </div>

            {!documentTypeId && (
              <div className="form-group">
                <label>Tipo di documento</label>
                <select
                  value={newDocumentType}
                  onChange={onNewDocumentTypeChange}
                  disabled={!newDocumentFileInputTouched}
                  className="form-control"
                >
                  <option
                    value=""
                  >
                    Seleziona un tipo...
                  </option>
                  {documentTypes.map((item, index) => {
                    return (
                      <option
                        value={item.id}
                        key={`select-document-type-option-${index}`}
                      >
                        {item.name}
                      </option>
                    )
                  })}
                </select>
                {newDocumentValidateErrors.type && (
                  <span className="text-danger">{newDocumentValidateErrors.type}</span>
                )}
              </div>
            )}

            <div className="form-group">
              {newDocumentSubmitting && (
                <p className="text-info">
                  Caricamento in corso...
                </p>
              )}
              {newDocumentError && (
                <p className="text-danger">
                  {newDocumentError}
                </p>
              )}
            </div>

            <div className="form-group" style={{marginTop: '25px', textAlign: 'center'}}>
              <a
                onClick={onNewDocumentSubmit}
                className="btn btn-download-user"
              >
                Carica Documento
              </a>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FileManager/FileManager.js